import React, { FunctionComponent } from 'react'

import { PROPERTY_TYPES } from '../../../common/drmTypes'
import { useAppSelector } from '../../../redux/hooks'
import { CadastralImportBox } from '../CadastralImportBox/CadastralImportBox'
import { PageLayoutTabContainer } from '../PageLayoutTabContainer/PageLayoutTabContainer'
import { PropertyDetailFetchError } from '../PropertyDetailFetchError/PropertyDetailFetchError'
import { PropertyDetailPriceUnit } from '../PropertyDetailPriceUnit/PropertyDetailPriceUnit'

export const PropertyDetailPrice: FunctionComponent = () => {
  const crmDrmData = useAppSelector(state => state.property.crm.data)
  const priceError = useAppSelector(state => state.property.price.error)
  const { data: ruianDetail, error } = useAppSelector(
    state => state.property.ruian
  )

  if (error || priceError)
    return (
      <PageLayoutTabContainer>
        <PropertyDetailFetchError
          description="Je nám líto, ale nepodařilo se se načíst informace o cenových údajích."
          message="Cenové údaje nenalezeny"
        />
      </PageLayoutTabContainer>
    )

  if (crmDrmData === false) {
    return (
      <PageLayoutTabContainer>
        <CadastralImportBox
          size="large"
          entityType="property"
          classNameInner="!py-20 mb-4"
          className="px-2"
        />
      </PageLayoutTabContainer>
    )
  }

  return (
    <PageLayoutTabContainer>
      <div className="flex flex-col space-y-2 animate-fadeIn w-full">
        {ruianDetail?.type === PROPERTY_TYPES.UNIT && (
          <PropertyDetailPriceUnit />
        )}
        {/* 
          {ruianDetail?.type === PROPERTY_TYPES.BUILDING && ()}
          {ruianDetail?.type === PROPERTY_TYPES.AREA && ()}
          */}
      </div>
    </PageLayoutTabContainer>
  )
}
